


















import instantSearchRouter from './instantsearch-router'

# Import typical instantsearch UI components
import {
	AisConfigure
	AisInstantSearchSsr
	createServerRootMixin
} from 'vue-instantsearch'

# Other Algolia deps
import algoliasearch from 'algoliasearch/lite'
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings'
import renderToString from 'vue-server-renderer/basic'
import { connectPagination } from 'instantsearch.js/es/connectors';

# Export the component
export default

	# Register instantsearch components
	components: {
		AisConfigure
		AisInstantSearchSsr
	}

	props:
		indexName: String
		hitsPerPage: Number
		usesInfiniteHits: Boolean
		filters: String

	provide: -> $_ais_ssrInstantSearchInstance: @instantsearch

	# Get the initial state
	serverPrefetch: ->
		algoliaState = await @instantsearch.findResultsState
			component: this
			renderToString: (app) -> new Promise (resolve, reject) ->
				renderToString app, (err, res) ->
					if err then reject(err)
					resolve(res)
		@$ssrContext.nuxt.algoliaState = algoliaState

	# Set initial state
	data: ->

		# Make the Algolia search client
		@searchClient = algoliasearch process.env.ALGOLIA_APP_ID,
			process.env.ALGOLIA_SEARCH_KEY

		# This is used by Algolia's routing and SSR features
		@serverRootMixin = createServerRootMixin {
			@searchClient
			@indexName
			routing:
				router: instantSearchRouter @$router
				stateMapping: singleIndex @indexName
		}
		algoliaMixin = @serverRootMixin.data()

		# Assuming we're using infinite-hits, clear the effect of pagination.
		# Algolia was throwing an error similar about search widgets not being
		# found. This wouldn't work with SSG anyhow.
		if @usesInfiniteHits
		then algoliaMixin.instantsearch.mainIndex.addWidgets([
			connectPagination(-> null)({ })
		])

		# Set data
		{
			...algoliaMixin
			initialQuery:
				query: null
				refinementList: null
		}

	beforeMount: ->

		# Capture the intial query state, for deep linking
		@initialQuery.query = @$route.query.query
		@initialQuery.refinementList = @$route.query.refinementList
		@initialQuery.page = @$route.query.page

		# Hydrate Algolia from prefetched data
		results = @$nuxt.context?.nuxtState.algoliaState ||
			window.__NUXT__.algoliaState
		@instantsearch.hydrate results if results

		# Remove the SSR state so it can't be applied again by mistake
		delete @$nuxt.context.nuxtState.algoliaState
		delete window.__NUXT__.algoliaState

	# Re-apply deeply linked query params
	mounted: -> @reapplyInitialQuery()

	# Cleanup on navigation
	beforeDestroy: -> @instantsearch.dispose()

	computed:

		# Make the facet configuration of the initial refinementList
		intialQueryFacetFilters: ->
			return unless @initialQuery.refinementList
			Object.entries @initialQuery.refinementList
			.map ([ facetKey, choices ]) ->
				choices.map (categorySlug) ->
					"#{facetKey}:#{categorySlug}"

	methods:

		# Algolia doesn't automatically apply the query parms since they weren't
		# baked into the result set that was captured during SSG, so apply them
		# after SSG.
		reapplyInitialQuery: -> @$defer =>
			helper = @instantsearch.helper
			return unless @initialQuery.query ||
				@initialQuery.refinementList ||
				(@usesInfiniteHits and @initialQuery.page)

			# Apply text string
			if @initialQuery.query
			then helper.setQuery @initialQuery.query

			# Add facets
			if @intialQueryFacetFilters
			then for facetKey, choices of @initialQuery.refinementList
				for choice in choices
					helper.addDisjunctiveFacetRefinement facetKey, choice

			# Always start on first page
			if @usesInfiniteHits and @initialQuery.page
				helper.setPage 0

			# Run the search
			await helper.search()

			# Load pages up to the deep linked page
			if @usesInfiniteHits and @initialQuery.page
				page = 0
				while ++page < @initialQuery.page
					helper.setPage page
					await helper.search()

